import { DEFAULT_MODULOR_DOMAIN } from '../../constants/modulorDomain';

const rtlIconSet = new Set<string>();
let rtlAssetsLoaded: Promise<void> | null = null;

const STORAGE_KEY = 'modulor-rtl-icons-cache';

async function loadRtlIcons(modulorDomain: string): Promise<void> {
  if (rtlAssetsLoaded) return rtlAssetsLoaded;

  rtlAssetsLoaded = (async () => {
    try {
      const cached = localStorage.getItem(STORAGE_KEY);
      if (cached) {
        const icons = JSON.parse(cached);
        icons.forEach((icon: string) => rtlIconSet.add(icon));
        return;
      }

      const url = `https://${modulorDomain}/metadata/default/rtlAssets.json`;
      const res = await fetch(url);
      const json = await res.json();

      const icons = json.rtlIcons || [];
      icons.forEach((icon: string) => rtlIconSet.add(icon));
      localStorage.setItem(STORAGE_KEY, JSON.stringify(icons));
    } catch (error) {
      console.error('Failed to load rtlAssets:', error);
    }
  })();

  return rtlAssetsLoaded;
}

export async function getUrlByAssetName(
  name: string,
  theme: string,
  modulorDomain: string = DEFAULT_MODULOR_DOMAIN,
  isRTL?: boolean,
): Promise<string> {
  const formattedName = name?.replace(/-/g, '_') ?? '';

  if (isRTL) {
    await loadRtlIcons(modulorDomain);

    if (rtlIconSet.has(formattedName)) {
      return `https://${modulorDomain}/assets/icons/${theme}/ic_24_rtl_${formattedName}.svg`;
    }
  }

  return `https://${modulorDomain}/assets/icons/${theme}/ic_24_${formattedName}.svg`;
}
